import { QuestionRegulatoryData, Questionnaire, QuestionnaireQuestion } from "../../Models/Surveys/SurveyDataModel";
import { BaseRegulationLogicManager } from "../BaseRegulationLogicManager";
import ResourcesConstants from "../ResourceConstants";
import {ComplianceScoreResult, InventoryDetailsResponse} from "../../StateControllers/Survey/SurveyResponse/SurveyResponseModels";

export class ReachAuthorizationCustomLogicManager extends BaseRegulationLogicManager {
    public static ReachSvhcAuthorizationRegulationId = "3908f984-c9ad-4b00-a499-e6f035abcda4";

    private readonly containSubstAnnexXIVKey: string = "reach_authv2_contains_substance";
    private readonly relevantSubstAnnexXIVKey: string = "reach_Annex_XIV_substances";
    private readonly containSubstAnnexXVIIKey: string = "reach_Annex_XVII";
    private readonly relevantSubstAnnexXVIIKey: string = "reach_Annex_XVII_substances";

    constructor(questions: QuestionnaireQuestion[], overallQuestionnaire: Questionnaire, questionRegulatoryData: QuestionRegulatoryData[], selectedInventory: InventoryDetailsResponse | null, complianceScoreResult: ComplianceScoreResult | null) {
        super(questions, overallQuestionnaire, questionRegulatoryData, selectedInventory, complianceScoreResult);
    }

    protected getAdditionalQuestionIndicesToHide = (question: QuestionnaireQuestion, questionIndex: number, indicesToHideOrShow: boolean[]) => {
        let childQuestion = -1;

        const ret: number[] = [];

        switch (question.summaryFieldKey) {
            case this.containSubstAnnexXIVKey: {
                childQuestion = this._questions.findIndex(q => q.summaryFieldKey == this.relevantSubstAnnexXIVKey);
                break;
            }
            case this.containSubstAnnexXVIIKey: {
                childQuestion = this._questions.findIndex(q => q.summaryFieldKey == this.relevantSubstAnnexXVIIKey);
                break;
            }           
        }

        indicesToHideOrShow[childQuestion] = question.value !== ResourcesConstants.NativeAnswerTexts.YesAnswer;

        return indicesToHideOrShow;
    }
}
